import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { CompanyProfileLayout } from 'components/layout/CompanyProfileLayout';
import { ProfilePicture } from '@getro/rombo';
import { ExternalLink } from 'lucide-react';
import { addProtocolToUrl } from 'helpers/urlHelpers';
import strings from 'strings';
import { useSelector } from 'react-redux';
import { activeNetworkSelector } from 'redux/selectors';
import MainLayout from 'components/layout/Main';
import { useCompanyLayoutName } from 'hooks/useCompanyLayoutName';
import useCompany from 'hooks/useCompany';
import usePageHook from '../../hooks/usePageHook';

export const CompanyJobBoard = () => {
  const activeNetwork = useSelector(activeNetworkSelector);
  const { company, initialized } = useCompany();
  const { isInCompanyProfileOrNetwork } = useCompanyLayoutName(initialized);
  usePageHook('Company job boards');

  return (
    <MainLayout containerProps={{ pb: '0px', minHeight: '100vh' }}>
      <CompanyProfileLayout
        isCompanyNetwork={activeNetwork.isCompany}
        title="Company profile"
        description={strings.companyProfile.description}
        isInCompanyProfileOrNetwork={isInCompanyProfileOrNetwork}
      >
        <Flex sx={{ flexDirection: 'column', gap: '24px', width: '100%', maxWidth: '600px', mx: 'auto', mt: '24px' }}>
          <Text sx={{ fontSize: '14px' }}>Your company and jobs are currently being promoted in these job boards:</Text>
          <Flex sx={{ flexDirection: 'column', gap: '16px' }}>
            {company?.jobBoardCollections?.map((jobBoard) => (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr',
                  justifyContent: 'space-between',
                  gap: '8px',
                  p: '8px 8px 16px 8px',
                  borderBottom: '1px solid',
                  borderBottomColor: 'border.subtle',
                  alignItems: 'center',
                }}
                key={jobBoard.id}
              >
                <Flex sx={{ alignItems: 'center', gap: '8px' }}>
                  <ProfilePicture variant="square" size="32px" imageUrl={jobBoard.logoUrl} name={jobBoard.name} />
                  <Text color="text.dark" fontSize="14px" fontWeight="400">
                    {jobBoard.name}
                  </Text>
                </Flex>
                <Text sx={{ justifySelf: 'center', color: 'text.main', fontSize: '14px', fontWeight: '400' }}>
                  {jobBoard.domain}
                </Text>
                <Flex sx={{ alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
                  {jobBoard.url && (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: 'text.main',
                        textDecoration: 'none',
                      }}
                      as="a"
                      href={addProtocolToUrl(jobBoard.url)}
                      target="_blank"
                    >
                      <Box as="span">Open</Box>
                      <Box as={ExternalLink} size="16px" />
                    </Box>
                  )}
                </Flex>
              </Box>
            ))}
          </Flex>
        </Flex>
      </CompanyProfileLayout>
    </MainLayout>
  );
};

export default CompanyJobBoard;
